import {FC} from "react";

export const FieldError: FC<{ message: string | null | undefined }> = (props) => {
    if (!props.message) return <></>;
    return (<p style={{color: "red"}}>{props.message}</p>);
}
